import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
export default {
    //分页查询
    selectPage(q){
        return http({
            url: '/api/swyl/v1/resourcePool/selectPage',
            method: 'post',
            params: q
        });
    },
    //判断是否可以修改数据
    checkUpdate(q){
        return http({
            url: '/api/swyl/v1/resourcePool/isUpdate',
            method: 'post',
            params: q
        });
    },
    //根据id更新
    updateById(q){
        return http({
            url: '/api/swyl/v1/resourcePool/updateById',
            method: 'post',
            params: q
        });
    },
    //获取特价项目集合
    selectProList(q){
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/selectProjectList',
            method: 'post',
            params: q
        });
    },
    //提交预借
    submitAdvance(data){
        return http.post('/api/swyl/v1/poolAdvance/submitAdvance', data);
    },
    //预借审批
    shpAdvance(data){
        return http({
            url: '/api/swyl/v1/poolAdvance/shpAdvance',
            method: 'post',
            params: data
        });
    },
    //预借列表分页查询
    selectAdPage(q){
        return http({
            url: '/api/swyl/v1/poolAdvance/selectPage',
            method: 'post',
            params: q
        });
    },
    //预借详情
    getAdvanceDetail(q){
        return http({
            url: '/api/swyl/v1/poolAdvance/selectById',
            method: 'post',
            params: q
        });
    },
    //分页查询
    selectDetailPage(q){
        return http({
            url: '/api/swyl/v1/poolDetail/selectPage',
            method: 'post',
            params: q
        });
    },
    //分页查询
    selectTotalPage(q){
        return http({
            url: '/api/swyl/v1/poolDetail/selectTotalPage',
            method: 'post',
            params: q
        });
    },
    //获取资源池汇总表头信息
    getTotalResourceData(q){
        return http({
           url:'/api/swyl/v1/resourcePool/getTotalResourceData',
           method:'post',
           params: q,
        });
    },
    getAuthByCode(q){
        return http({
            url:'/api/swyl/v1/bscUserAuth/getByCode',
            method:'post',
            params: q,
        });
    },
    //计算本月资源池余额
    calResource(q){
        return http({
            url:'/api/swyl/v1/resourcePool/calResource',
            method:'post',
            params: q,
        });
    },

    //计算本月资源池余额
    getBalance(q){
        return http({
            url:'/api/swyl/v1/resourcePool/getBalance',
            method:'post',
            params: q,
        });
    },

    getAreaForecast(q){
        return http({
            url:'/api/swyl/v1/bscAreaForecastTrend/selectPage',
            method:'post',
            params: q,
        });
    },

    getTableHeader(q){
        return http({
            url:'/api/swyl/v1/bscAreaForecastTrend/getTableHeader',
            method:'post',
            params: q,
        });
    },

}